import { useEffect, useState } from 'react';
import { useField } from 'formik';
import CustomerIconOutlined from 'components/icons/CustomerIconOutlined';
import FormSectionHeader from 'components/new-ui/base/form/FormSectionHeader';
import ReadonlyFormItem from 'components/new-ui/base/form/ReadonlyFormItem';
import { useMultiStepFormContext } from 'components/new-ui/composed/multistep-form/MultiStepFormProvider';
import { getCustomer } from 'store/customers/client';
import { useBrokerUploadContext } from '../BrokerUploadProvider';
import { BrokerUploadSteps } from '../types';

const stepKey = BrokerUploadSteps.CUSTOMER;
const fieldName = 'customer.customerId';

const CustomerStep = () => {
    const [, , helpers] = useField(fieldName);
    const { isIdle, isActive, isComplete } = useMultiStepFormContext<any>();
    const { selectedJob } = useBrokerUploadContext();
    const [customerName, setCustomerName] = useState<string | undefined>(selectedJob?.customer?.name);

    const customerId = selectedJob?.customer?.id ?? selectedJob?.customerId ?? '';
    const isActiveStep = isActive(stepKey);

    useEffect(() => {
        if (isActiveStep && customerId) helpers.setValue(customerId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId, isActiveStep]);

    useEffect(() => {
        if (selectedJob?.customer?.name) {
            setCustomerName(selectedJob.customer.name);
        } else if (customerId) {
            getCustomer(customerId)
                .then((c) => setCustomerName(c.name))
                .catch(() => setCustomerName(customerId));
        }
    }, [customerId, selectedJob?.customer?.name]);

    const sectionTitle = 'Customer';

    if (isIdle(stepKey)) {
        return <FormSectionHeader title={sectionTitle} icon={<CustomerIconOutlined />} />;
    }

    if (isActive(stepKey) || isComplete(stepKey)) {
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <FormSectionHeader title={sectionTitle} icon={<CustomerIconOutlined />} />
                <ReadonlyFormItem disabled value={customerName} />
            </div>
        );
    }

    return null;
};

export default CustomerStep;
